var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formData
    ? _c("div", { staticClass: "fin-form solid-table" }, [
        _c(
          "div",
          { staticClass: "fin-form-content transtant-input" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  size: "mini",
                  model: _vm.formData,
                  "label-suffix": "：",
                  "label-width": "350px",
                  rules: _vm.rules
                }
              },
              [
                _c(
                  "el-collapse",
                  {
                    model: {
                      value: _vm.collapseModel,
                      callback: function($$v) {
                        _vm.collapseModel = $$v
                      },
                      expression: "collapseModel"
                    }
                  },
                  [
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "施工辅助工程", name: "assist" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "powerProjectPrice",
                            attrs: {
                              label: "施工供电工程单价（元/MW）",
                              prop: "powerProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("powerProjectPrice")
                              },
                              model: {
                                value: _vm.formData.powerProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "powerProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.powerProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "waterProjectPrice",
                            attrs: {
                              label: "施工供水工程单价（元/MW）",
                              prop: "waterProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("waterProjectPrice")
                              },
                              model: {
                                value: _vm.formData.waterProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "waterProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.waterProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "auxiliaryProjectPrice",
                            attrs: {
                              label: "其他施工辅助工程单价（元/MW）",
                              prop: "auxiliaryProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("auxiliaryProjectPrice")
                              },
                              model: {
                                value: _vm.formData.auxiliaryProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "auxiliaryProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.auxiliaryProjectPrice"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "设备及安装工程", name: "device" } },
                      [
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 发电场设备及安装工程 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectTurbinePrice",
                            attrs: {
                              label: "风电机组单价（元/kW）",
                              prop: "installProjectTurbinePrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectTurbinePrice"),
                                title: "设备费用"
                              },
                              model: {
                                value: _vm.formData.installProjectTurbinePrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectTurbinePrice",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectTurbinePrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectTurbineCoefficient",
                            attrs: {
                              label: "风电机组安装费用系数（%）",
                              prop: "installProjectTurbineCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectTurbineCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectTurbineCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectTurbineCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectTurbineCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectTowerBarrelPrice",
                            attrs: {
                              label: "塔筒单价（万元/台）",
                              prop: "installProjectTowerBarrelPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectTowerBarrelPrice"
                                ),
                                title: "设备费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectTowerBarrelPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectTowerBarrelPrice",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectTowerBarrelPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectTowerBarrelCoefficient",
                            attrs: {
                              label: "塔筒安装费用系数（%）",
                              prop: "installProjectTowerBarrelCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectTowerBarrelCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .installProjectTowerBarrelCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectTowerBarrelCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectTowerBarrelCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectBoxPrice",
                            attrs: {
                              label: "箱变单价（万元/台）",
                              prop: "installProjectBoxPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectBoxPrice"),
                                title: "设备费用"
                              },
                              model: {
                                value: _vm.formData.installProjectBoxPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectBoxPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.installProjectBoxPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectBoxCoefficient",
                            attrs: {
                              label: "箱变安装费用系数（%）",
                              prop: "installProjectBoxCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectBoxCoefficient"),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectBoxCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectBoxCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectBoxCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectLinePrice",
                            attrs: {
                              label: "集电线路（万元/km）",
                              prop: "installProjectLinePrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectLinePrice"),
                                title: "设备费用"
                              },
                              model: {
                                value: _vm.formData.installProjectLinePrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectLinePrice",
                                    $$v
                                  )
                                },
                                expression: "formData.installProjectLinePrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectLineCoefficient",
                            attrs: {
                              label: "集电线路费用系数（%）",
                              prop: "installProjectLineCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectLineCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectLineCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectLineCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectLineCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 升压变电站设备及安装工程 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectBoosterPrice",
                            attrs: {
                              label: "升压站单价（元/kW）",
                              prop: "installProjectBoosterPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectBoosterPrice"),
                                title: "设备费用"
                              },
                              model: {
                                value: _vm.formData.installProjectBoosterPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectBoosterPrice",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectBoosterPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectBoosterCoefficient",
                            attrs: {
                              label: "升压站安装费用系数（%）",
                              prop: "installProjectBoosterCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectBoosterCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectBoosterCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectBoosterCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectBoosterCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 控制保护设备及安装工程 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectProtectionPrice",
                            attrs: {
                              label: "控制保护设备单价（元/kW）",
                              prop: "installProjectProtectionPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectProtectionPrice"
                                ),
                                title: "设备费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectProtectionPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectProtectionPrice",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectProtectionPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectProtectionCoefficient",
                            attrs: {
                              label: "控制保护设备安装费用系数（%）",
                              prop: "installProjectProtectionCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectProtectionCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .installProjectProtectionCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectProtectionCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectProtectionCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 其他设备及安装工程 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectOtherPrice",
                            attrs: {
                              label: "其他设备单价（元/kW）",
                              prop: "installProjectOtherPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("installProjectOtherPrice"),
                                title: "设备费用"
                              },
                              model: {
                                value: _vm.formData.installProjectOtherPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectOtherPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.installProjectOtherPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "installProjectOtherCoefficient",
                            attrs: {
                              label: "其他设备安装费用系数（%）",
                              prop: "installProjectOtherCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "installProjectOtherCoefficient"
                                ),
                                title: "安装费用"
                              },
                              model: {
                                value:
                                  _vm.formData.installProjectOtherCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "installProjectOtherCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.installProjectOtherCoefficient"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "建筑工程", name: "project" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "windfarmProjectPrice",
                            attrs: {
                              label: "发电厂工程单价（元/kW）",
                              prop: "windfarmProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("windfarmProjectPrice"),
                                title: "发电工程费用"
                              },
                              model: {
                                value: _vm.formData.windfarmProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "windfarmProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.windfarmProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "boosterProjectPrice",
                            attrs: {
                              label: "升压变电工程单价（元/kW）",
                              prop: "boosterProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("boosterProjectPrice"),
                                title: "升压变电费用"
                              },
                              model: {
                                value: _vm.formData.boosterProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "boosterProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.boosterProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "houseArea",
                            attrs: {
                              label: "房屋面积（m2）",
                              prop: "houseArea"
                            }
                          },
                          [
                            _vm.backend
                              ? _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: _vm.formData.houseArea,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "houseArea", $$v)
                                    },
                                    expression: "formData.houseArea"
                                  }
                                })
                              : _c("span", [_vm._v(_vm._s(_vm.data.houseArea))])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "housebuildersProjectPrice",
                            attrs: {
                              label: "单价（元/m2）",
                              prop: "housebuildersProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("housebuildersProjectPrice"),
                                title: "房屋建筑费用"
                              },
                              model: {
                                value: _vm.formData.housebuildersProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "housebuildersProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.housebuildersProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "trafficProjectPrice",
                            attrs: {
                              label: "场内交通工程单价（万元/km）",
                              prop: "trafficProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("trafficProjectPrice"),
                                title: "场内交通费用"
                              },
                              model: {
                                value: _vm.formData.trafficProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "trafficProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.trafficProjectPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "otherProjectPrice",
                            attrs: {
                              label: "其他工程单价（元/kW）",
                              prop: "otherProjectPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("otherProjectPrice"),
                                title: "其他工程费用"
                              },
                              model: {
                                value: _vm.formData.otherProjectPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "otherProjectPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.otherProjectPrice"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "其他费用", name: "other" } },
                      [
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 项目建设用地费 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "landAcquisitionPrice",
                            attrs: {
                              label: "土地征用单价（元/亩/年）",
                              prop: "landAcquisitionPrice"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.landAcquisitionPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "landAcquisitionPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.landAcquisitionPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "boosterProjectPrice",
                            attrs: {
                              label: "征地面积（亩）",
                              prop: "boosterProjectPrice"
                            }
                          },
                          [
                            _vm.backend
                              ? _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: _vm.formData.landAcquisitionArea,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "landAcquisitionArea",
                                        $$v
                                      )
                                    },
                                    expression: "formData.landAcquisitionArea"
                                  }
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.data.landAcquisitionArea))
                                ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "landAcquisitionProjectCycle",
                            attrs: {
                              label: "项目周期（年）",
                              prop: "landAcquisitionProjectCycle"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("landAcquisitionProjectCycle"),
                                title: "土地征用费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.landAcquisitionProjectCycle,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "landAcquisitionProjectCycle",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.landAcquisitionProjectCycle"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "temporaryLandRentalPrice",
                            attrs: {
                              label: "临时用地单价（元/亩/年）",
                              prop: "temporaryLandRentalPrice"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.temporaryLandRentalPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "temporaryLandRentalPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.temporaryLandRentalPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "trafficProjectPrice",
                            attrs: {
                              label: "临时用地面积（亩）",
                              prop: "trafficProjectPrice"
                            }
                          },
                          [
                            _vm.backend
                              ? _c("el-input", {
                                  attrs: { placeholder: "请输入" },
                                  model: {
                                    value: _vm.formData.temporaryLandArea,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "temporaryLandArea",
                                        $$v
                                      )
                                    },
                                    expression: "formData.temporaryLandArea"
                                  }
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.data.temporaryLandArea))
                                ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "temporaryLandRentalCycle",
                            attrs: {
                              label: "用地周期（年）",
                              prop: "temporaryLandRentalCycle"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("temporaryLandRentalCycle"),
                                title: "临时用地费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.temporaryLandRentalCycle,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "temporaryLandRentalCycle",
                                    $$v
                                  )
                                },
                                expression: "formData.temporaryLandRentalCycle"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "migrationCompensationArea",
                            attrs: {
                              label: "补偿面积（亩）",
                              prop: "migrationCompensationArea"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.migrationCompensationArea,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "migrationCompensationArea",
                                    $$v
                                  )
                                },
                                expression: "formData.migrationCompensationArea"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "migrationCompensationPrice",
                            attrs: {
                              label: "补偿用地单价（元/亩）",
                              prop: "migrationCompensationPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("migrationCompensationPrice"),
                                title: "迁移补偿费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.migrationCompensationPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "migrationCompensationPrice",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.migrationCompensationPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "residualCleaningCoefficient",
                            attrs: {
                              label: "余物清理系数（%）",
                              prop: "residualCleaningCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("residualCleaningCoefficient"),
                                title: "余物清理费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.residualCleaningCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "residualCleaningCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.residualCleaningCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 项目建设管理费 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectPrePaymentCoefficient",
                            attrs: {
                              label: "工程前期费用系数（%）",
                              prop: "projectPrePaymentCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("projectPrePaymentCoefficient"),
                                title: "工程前期费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData.projectPrePaymentCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectPrePaymentCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectPrePaymentCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectConstructionManagementCoefficient",
                            attrs: {
                              label: "工程建设管理费用系数（%）",
                              prop: "projectConstructionManagementCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "projectConstructionManagementCoefficient"
                                ),
                                title: "工程建设管理费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .projectConstructionManagementCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectConstructionManagementCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectConstructionManagementCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectConstructionSupervisionCoefficient",
                            attrs: {
                              label: "工程建设监理费用系数（%）",
                              prop: "projectConstructionSupervisionCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "projectConstructionSupervisionCoefficient"
                                ),
                                title: "工程建设监理费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .projectConstructionSupervisionCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectConstructionSupervisionCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectConstructionSupervisionCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectConsultingServiceCoefficient",
                            attrs: {
                              label: "项目咨询服务费用系数（%）",
                              prop: "projectConsultingServiceCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "projectConsultingServiceCoefficient"
                                ),
                                title: "项目咨询服务费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .projectConsultingServiceCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectConsultingServiceCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectConsultingServiceCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectTechnoEconomicsAssessCoefficient",
                            attrs: {
                              label: "项目技术经济评审费用系数（%）",
                              prop: "projectTechnoEconomicsAssessCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "projectTechnoEconomicsAssessCoefficient"
                                ),
                                title: "项目技术经济评审费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .projectTechnoEconomicsAssessCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectTechnoEconomicsAssessCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectTechnoEconomicsAssessCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectInspectionCoefficient",
                            attrs: {
                              label: "项目验收费用系数（%）",
                              prop: "projectInspectionCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("projectInspectionCoefficient"),
                                title: "项目验收费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData.projectInspectionCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectInspectionCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectInspectionCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "projectInsuranceCoefficient",
                            attrs: {
                              label: "工程保险费用系数（%） ",
                              prop: "projectInsuranceCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("projectInsuranceCoefficient"),
                                title: "工程保险费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.projectInsuranceCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "projectInsuranceCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.projectInsuranceCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 生产准备费 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "personnelTrainEntranceCoefficient",
                            attrs: {
                              label: "人员培训及提前进场费用系数（%）",
                              prop: "personnelTrainEntranceCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "personnelTrainEntranceCoefficient"
                                ),
                                title: "人员培训及提前进场费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .personnelTrainEntranceCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "personnelTrainEntranceCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.personnelTrainEntranceCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "managementEquipmentPurchaseCostCoefficient",
                            attrs: {
                              label: "管理用具购置费建安费用系数（%） ",
                              prop: "managementEquipmentPurchaseCostCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "managementEquipmentPurchaseCostCoefficient"
                                ),
                                title: "管理用具购置费建安费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .managementEquipmentPurchaseCostCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "managementEquipmentPurchaseCostCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.managementEquipmentPurchaseCostCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref:
                              "utensilProductionFurniturePurchaseCoefficient",
                            attrs: {
                              label: "工器具及生产家具购置费用系数（%）",
                              prop:
                                "utensilProductionFurniturePurchaseCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "utensilProductionFurniturePurchaseCoefficient"
                                ),
                                title: "工器具及生产家具购置费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .utensilProductionFurniturePurchaseCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "utensilProductionFurniturePurchaseCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.utensilProductionFurniturePurchaseCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "repairPiecePurchaseCoefficient",
                            attrs: {
                              label: "备品备件购置费用系数（%）",
                              prop: "repairPiecePurchaseCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "repairPiecePurchaseCoefficient"
                                ),
                                title: "备品备件购置费用",
                                inline: false
                              },
                              model: {
                                value:
                                  _vm.formData.repairPiecePurchaseCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "repairPiecePurchaseCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.repairPiecePurchaseCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "uniteRunningCoefficient",
                            attrs: {
                              label: "联合试运转费用系数（%）",
                              prop: "uniteRunningCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("uniteRunningCoefficient"),
                                title: "联合试运转费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.uniteRunningCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "uniteRunningCoefficient",
                                    $$v
                                  )
                                },
                                expression: "formData.uniteRunningCoefficient"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 勘察设计费 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "surveyPrice",
                            attrs: {
                              label: "勘察费用单价（元/kW）",
                              prop: "surveyPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("surveyPrice"),
                                title: "勘察费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.surveyPrice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "surveyPrice", $$v)
                                },
                                expression: "formData.surveyPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "designPrice",
                            attrs: {
                              label: "设计费用单价（元/kW）",
                              prop: "designPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("designPrice"),
                                title: "设计费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.designPrice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "designPrice", $$v)
                                },
                                expression: "formData.designPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "otherPrice",
                            attrs: {
                              label: "其他费用单价（元/kW）",
                              prop: "otherPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("otherPrice"),
                                title: "其他费用",
                                inline: false
                              },
                              model: {
                                value: _vm.formData.otherPrice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "otherPrice", $$v)
                                },
                                expression: "formData.otherPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v(" 其他税费 ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "otherTaxesPrice",
                            attrs: {
                              label: "其他税费单价（元/kW）",
                              prop: "otherTaxesPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("otherTaxesPrice"),
                                title: "其他税费"
                              },
                              model: {
                                value: _vm.formData.otherTaxesPrice,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "otherTaxesPrice", $$v)
                                },
                                expression: "formData.otherTaxesPrice"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "基本预备费用", name: "basic" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "basicReserveCoefficient",
                            attrs: {
                              label: "基本预备费用系数（%）",
                              prop: "basicReserveCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("basicReserveCoefficient")
                              },
                              model: {
                                value: _vm.formData.basicReserveCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "basicReserveCoefficient",
                                    $$v
                                  )
                                },
                                expression: "formData.basicReserveCoefficient"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "价差预备费用", name: "diff" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "priceDifferenceReserveCoefficient",
                            attrs: {
                              label: "价差预备费用系数（%）",
                              prop: "priceDifferenceReserveCoefficient"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee(
                                  "priceDifferenceReserveCoefficient"
                                )
                              },
                              model: {
                                value:
                                  _vm.formData
                                    .priceDifferenceReserveCoefficient,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "priceDifferenceReserveCoefficient",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.priceDifferenceReserveCoefficient"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "建设期利息", name: "interest" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "constructionPeriod",
                            attrs: {
                              label: "建设周期（年）",
                              prop: "constructionPeriod"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.constructionPeriod,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "constructionPeriod",
                                    $$v
                                  )
                                },
                                expression: "formData.constructionPeriod"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "lendingRate",
                            attrs: {
                              label: "贷款利率（%）",
                              prop: "lendingRate"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.lendingRate,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "lendingRate", $$v)
                                },
                                expression: "formData.lendingRate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "capitalRatio",
                            attrs: {
                              label: "资本金比例（%）",
                              prop: "capitalRatio"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                title: "利息",
                                fee: _vm.getFee("capitalRatio")
                              },
                              model: {
                                value: _vm.formData.capitalRatio,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "capitalRatio", $$v)
                                },
                                expression: "formData.capitalRatio"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-item",
                      { attrs: { title: "送出工程投资", name: "outProject" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "sendOutLineLength",
                            attrs: {
                              label: "送出线路长度（km）",
                              prop: "sendOutLineLength"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.formData.sendOutLineLength,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "sendOutLineLength",
                                    $$v
                                  )
                                },
                                expression: "formData.sendOutLineLength"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            ref: "sendOutLineLengthPrice",
                            attrs: {
                              label: "送出线路单价（万元/km）",
                              prop: "sendOutLineLengthPrice"
                            }
                          },
                          [
                            _c("fee-input", {
                              attrs: {
                                placeholder: "请输入",
                                fee: _vm.getFee("sendOutLineLengthPrice"),
                                inline: false
                              },
                              model: {
                                value: _vm.formData.sendOutLineLengthPrice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "sendOutLineLengthPrice",
                                    $$v
                                  )
                                },
                                expression: "formData.sendOutLineLengthPrice"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottom-tool" },
          [
            _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")]),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.save } },
              [_vm._v(_vm._s(_vm.backend ? "保存" : "保存并计算"))]
            )
          ],
          1
        )
      ])
    : _c("div", [
        _c("div", { staticClass: "fin-form empty-form" }, [_vm._v("暂无数据")])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }